import { render, staticRenderFns } from "./ChargingRateDetail.vue?vue&type=template&id=70b827cc&scoped=true&"
import script from "./ChargingRateDetail.vue?vue&type=script&lang=js&"
export * from "./ChargingRateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChargingRateDetail.vue?vue&type=style&index=0&id=70b827cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b827cc",
  null
  
)

export default component.exports